import { BaseFormula } from "../../BaseFormula";
import { CalculationResult } from "../../CalculationResult";
import { ChangeType } from "../../ChangeType";
import { CostData } from "../../CostData";

export class Formula_ModifiedZScore extends BaseFormula
{
    evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { threshold: number }, show_new_cost: boolean): CalculationResult
    {
        let err = this.checkLength(data, 2, show_new_cost);
        if (err)
            return err;

        let median = BaseFormula.median(data.map(d => d.amount));
        let deviations = data.map(x => Math.abs(x.amount - median));
        let mad = BaseFormula.median(deviations);

        if (mad === 0)
            return {
                value: null,
                reason: `MAD is zero.`,
                values: { median, mad }
            };

        let modified_z_score = (0.6745 * (value.amount - median)) / mad;

        err = this.checkChnage(change, modified_z_score, { median, mad, modified_z_score });
        if (err)
            return err;

        return {
            value: Math.abs(modified_z_score) > parameters.threshold,
            values: { median, mad, modified_z_score }
        };
    }
} 